export default __webpack_public_path__ + "static/media/graduation-cap.8b2de6c5.png";